export function AngleDownIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
      <title>A n g l e D o w n</title>
      <path
        d="M10.25 3.88C10.11 3.74 9.92 3.66 9.72 3.66C9.52 3.66 9.33 3.74 9.19 3.88L6.5 6.53L3.84 3.88C3.7 3.74 3.51 3.66 3.32 3.66C3.12 3.66 2.93 3.74 2.79 3.88C2.72 3.947 2.66 4.03 2.62 4.12C2.59 4.21 2.57 4.31 2.57 4.41C2.57 4.51 2.59 4.61 2.62 4.7C2.66 4.79 2.72 4.87 2.79 4.94L5.97 8.12C6.037 8.19 6.12 8.25 6.21 8.29C6.3 8.32 6.4 8.34 6.5 8.34C6.6 8.34 6.7 8.32 6.79 8.29C6.88 8.25 6.96 8.19 7.03 8.12L10.25 4.94C10.32 4.87 10.38 4.79 10.41 4.7C10.452 4.61 10.47 4.51 10.47 4.41C10.47 4.31 10.452 4.21 10.41 4.12C10.38 4.03 10.32 3.947 10.25 3.88Z"
        fill="#8C959C"
      />
    </svg>
  );
}
